import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useUserStore from "../../../utils/storeApp";

const ReportsDropdown = () => {
  const { SetSharedObject } = useUserStore((state) => ({
    SetSharedObject: state.SetSharedObject,
  }));
  useEffect(() => {
    SetSharedObject("userDeleteActivity", []);
  }, []);
  return (
    <div className="ReportsDropdown spacer-inline spacer-margin6">
      <ul className="navbar-nav flex-grow">
        <li className="dropdown">
          <button
            className="form-control ht-5 dropdown-toggle"
            id="navbarDropdown"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="admin-nav2">User Reports</span>
          </button>
          <div
            className="dropdown-menu  shade-1"
            aria-labelledby="navbarDropdown"
          >
            <Link
              to={"/user-activity"}
              className="dropdown-item"
              onClick={(el) => {
                SetSharedObject("UserActiviySearch", {});
              }}
            >
              User Activity
            </Link>
            <Link
              to={"/delete-user-activity"}
              className="dropdown-item"
              onClick={(el) => {
                SetSharedObject("UserActiviySearch", {});
              }}
            >
              Delete Activity
            </Link>
            <Link
              to={"/mailbox-size"}
              className="dropdown-item"
              onClick={(el) => {
                SetSharedObject("UserActiviySearch", {});
              }}
            >
              Mailbox Size
            </Link>
            <Link
              to={"/user-status"}
              className="dropdown-item"
              onClick={(el) => {
                SetSharedObject("UserActiviySearch", {});
              }}
            >
              User Status
            </Link>
            <Link
              to={"/message-forwarding"}
              className="dropdown-item"
              onClick={(el) => {
                SetSharedObject("UserActiviySearch", {});
              }}
            >
              Message Forwarding
            </Link>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ReportsDropdown;
